import React  from 'react';
import { graphql, compose } from 'react-apollo';
import BaseWidget from '../../../../widgets/baseWidget';
import { getGoalsAndAveragesStatistics } from './queries/queries';
import DataProcessor from '../../common/dataProcessors/goalsAndAveragesDataProcessor';
import GoalsAndAveragesWidget from '../../common/widgets/goalsAndAverages';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class GoalsAndAverages extends BaseWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.group.allTime.goalsAndAverages
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'all time');
  }

  get comment() {
    return super.comment || <div className="chart-title">Event daily average per group member</div>;
  }

  render() {
    return (
      <GoalsAndAveragesWidget data={this.dataProcessor.data} title="All Time Goals and Averages"
                              comment={this.comment}
                              chartData={this.dataProcessor.chartData} chartTitle="Members Are Reaching Event Goal"
                              loading={this.props.data.loading}/>
    );
  }
}

export default compose(
  graphql(getGoalsAndAveragesStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(GoalsAndAverages);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/allTime/goalsAndAverages.js